import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const StyledIssueSelect = styled(Select)`
   width: 300px;
` as typeof Select;
